module.exports = __webpack_public_path__ + "img/allgemeine-struktur.e8430e7d.png";